import React from "react";

import Tooltip from "@material-ui/core/Tooltip";
import { Button, useNotify, useRefresh, useTranslate } from "react-admin";

import useUpdatePartial from "../_extensions/react-admin/core/dataProvider/useUpdatePartial";


export const RowActionButton = ({ resource, record, action, label, tooltip, isEnabled }) => {
	const refresh = useRefresh();
	const notify = useNotify();
	const t = useTranslate();

	const [update] = useUpdatePartial(
		resource,
		record.id,
		{},
		record,
		{
			mutationMode: "pessimistic",
			onSuccess: () => {
				notify(t(`resources.${resource}.${action}.success`), "info");
				refresh();
			},
			onFailure: (error) => {
				notify(error.message, "error");
			},
		},
		"update",
	);

	const handleClick = (e) => {
		e.stopPropagation();
		update();
	};

	if (!isEnabled(record)) {
		return null;
	}
	const button = <Button label={t(label)} onClick={handleClick} />;
	if (!tooltip) {
		return button;
	}
	return (
		<Tooltip title={t(tooltip)}>
			<span>{button}</span>
		</Tooltip>
	);
};
